<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.history', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <v-row justify="center">
          <v-expansion-panels inset v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header color="#00475A"
                >{{ $t("message.history.pm", { value: "default" }) }}
                <template v-slot:actions>
                  <v-icon color="#FFFFFF"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row align="center">
                  <v-col>
                      <vue-excel-xlsx
                          :data="exportedPmData"
                          :columns="getexportedColumns"
                          :file-name="'history_preventive_work_order'"
                          :file-type="'xlsx'"
                          :sheet-name="'history'"
                          >
                          <v-icon large color="green">mdi-file-excel</v-icon>
                      </vue-excel-xlsx>
                  </v-col>

                  <v-col offset-md="4"
                    ><v-text-field
                      v-model="searchpm"
                      append-icon="mdi-magnify"
                      :label="$t('message.search', { value: 'default' })"
                      single-line
                      hide-details
                    ></v-text-field
                  ></v-col>
                </v-row>

                <v-data-table
                  ref="pMTable"
                  :headers="headersPMTable"
                  :items="pmData"
                  :search="searchpm"
                  :loading="loading"
                  :loading-text="
                    $t('message.loadingText', { value: 'default' })
                  "
                  @current-items="getFilteredPmItems"
                >
                  <template v-slot:[`item.startdate`]="{ item }">
                    {{ formatedDate(item.startdate) }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    {{ getWoStatusText(item.status) }}
                  </template>
                  <template v-slot:[`item.enddate`]="{ item }">
                    {{ formatedDate(item.enddate) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-icon @click="showDetails(item.wonum)">mdi-eye</v-icon>
                  </template>
                  <template v-slot:[`item.ldescription`]="{ item }">
                    {{ filterHtml(item.ldescription) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header color="#00475A"
                >{{ $t("message.history.cm", { value: "default" }) }}
                <template v-slot:actions>
                  <v-icon color="#FFFFFF"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row align="center">
                  <v-col>
                      <vue-excel-xlsx
                          :data="exportedCmData"
                          :columns="getexportedColumns"
                          :file-name="'history_corrective_work_order'"
                          :file-type="'xlsx'"
                          :sheet-name="'history'"
                          >
                          <v-icon large color="green">mdi-file-excel</v-icon>
                      </vue-excel-xlsx>
                  </v-col>
                  <v-col offset-md="8">
                    <v-text-field
                      v-model="searchcm"
                      append-icon="mdi-magnify"
                      :label="$t('message.search', { value: 'default' })"
                      single-line
                      hide-details
                    ></v-text-field
                  ></v-col>
                </v-row>

                <v-data-table
                  ref="cMTable"
                  :headers="headersCMTable"
                  :items="cmData"
                  :search="searchcm"
                  light
                  @current-items="getFilteredCmItems"
                >
                  <template v-slot:[`item.startdate`]="{ item }">
                    {{ formatedDate(item.startdate) }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    {{ getWoStatusText(item.status) }}
                  </template>
                  <template v-slot:[`item.enddate`]="{ item }">
                    {{ formatedDate(item.enddate) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-icon @click="showDetails(item.wonum)">mdi-eye</v-icon>
                  </template>
                  <template v-slot:[`item.ldescription`]="{ item }">
                    {{ filterHtml(item.ldescription) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </div>

      <v-dialog
      v-model="showInt"
      width="800"
      overlay-color="#fff"
      overlay-opacity="0.5"
    >
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0 mb-3">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="showInt = false"
            >mdi-close</v-icon
          >
        </v-system-bar>

        <WorkorderInfo
          :protocols="protocols"
          :srs="srs"
          :workorder="workorder"
        ></WorkorderInfo>
      </v-card>
    </v-dialog>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import { mapActions, mapGetters } from "vuex";
import { formatMagicDate } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";
import WorkorderInfo from "../components/WorkorderInfo.vue";

export default {
  watch: {
    getterCurrentClient: function () {
      this.workordersHistory();
    },
  },
  methods: {
    ...mapActions("carpet", {
      actionGetHistories: "loadHistories",
    }),

    formatedDate(date) {
      if (date == "") {
        return "";
      }

      if (date == undefined) {
        return "";
      }

      if (date == null) {
        return "";
      }
      return formatMagicDate(date);
    },

    getWoStatusText(value) {
      switch (value) {
        case "APPROVED":
          return this.$t("message.status.approved", { value: "default" });
        case "APPR":
          return this.$t("message.status.approved", { value: "default" });
        case "WSCH":
          return this.$t("message.status.wait", { value: "default" });
        case "COMP":
          return this.$t("message.status.completed", { value: "default" });
        case "INPRG":
          return this.$t("message.status.inprogress", { value: "default" });
        case "CBC":
          return this.$t("message.status.ccanceled", { value: "default" });
        default:
          return "";
      }
    },

    downloadProtocol(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);
      window.open(file_path);
    },

    async showDetails(wonum) {
      this.workorder = this.getterHistories.find((e) => e.wonum == wonum);
      await MaximoService.getProtocolAndWheel(this.workorder.workorderid)
        .then((response) => {
          this.protocols = response.data;
          this.showProtocol = true;
        })
        .catch(() => {
          this.protocols = [];
          this.showProtocol = false;
        });
      await MaximoService.getRelatedRecords(this.workorder.wonum)
        .then((response) => {
          this.srs = response.data;
          if (this.srs.length == 0) {
            this.showAlert = false;
          } else {
            this.showAlert = true;
          }
        })
        .catch(() => {
          this.srs = [];

          this.showAlert = false;
        });
      this.showInt = true;
    },

    async workordersHistory() {
      this.loading = true;
      if (this.getterHistories.length == 0) {
        await this.actionGetHistories(this.getterCurrentClient);
      }

      this.getterHistories.forEach((item) => {
        if (item.worktype == "PM") {
          this.pmData.push(item);
        }

        if (item.worktype == "CM") {
          this.cmData.push(item);
        }
      });
      this.loading = false;
    },
    filterHtml(value) {
      if(value){
        let regex = /(<([^>]+)>)/ig;
        return value.replace(regex, "");
      }
    },
    getFilteredPmItems(){

          this.exportedPmData = this.$refs.pMTable ? this.$refs.pMTable.$children[0].filteredItems : this.pmData;
    },
    getFilteredCmItems(){
          this.exportedCmData = this.$refs.cMTable ? this.$refs.cMTable.$children[0].filteredItems : this.cmData;
    },
    getJobPlanTypeForExport(wonum){
      return this.getterHistories.find((e) => e.wonum == wonum).type
    }
  },
  mounted() {
    this.workordersHistory();
  },
  data() {
    return {
      panel: 0,
      pmData: [],
      cmData: [],
      searchpm: "",
      searchcm: "",
      protocols: [],
      srs: [],
      loading: true,
      protocolDialog: false,
      workorder: {},
      showProtocol: false,
      showAlert: false,
      showInt: false,
      exportedColumns : [],
      exportedPmData: [],
      exportedCmData: [],
            
    };
  },
  name: "HistoryPage",
  title: "History",

  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    WorkorderInfo,
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
    }),

    ...mapGetters("carpet", {
      getterHistories: "getHistories",
    }),

    headersCMTable() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "topLevel",
          sortable: true,
        },

        {
          text: this.$t("message.magic.workorder", { value: "default" }),
          value: "wonum",
          sortable: true,
        },
        {
          text: this.$t("message.magic.startDate", { value: "default" }),
          value: "startdate",
          sortable: true,
        },
        {
          text: this.$t("message.magic.endDate", { value: "default" }),
          value: "enddate",
          sortable: true,
        },
        {
          text: this.$t("message.magic.desc", { value: "default" }),
          value: "description",
          sortable: true,
        },
        {
          text: "Worklog",
          value: "ldescription",
          sortable: false,
        },
        {
          text: this.$t("message.magic.location", { value: "default" }),
          value: "locationdesc",
          sortable: false,
        },
        {
          text: this.$t("message.magic.details", { value: "default" }),
          value: "action",
          sortable: false,
        },
      ];
    },

    getexportedColumns(){
      return [
        {
          label: this.$t("message.pageKm.loco", { value: "default" }),
          field: "topLevel",
        },

        {
          label: this.$t("message.magic.workorder", { value: "default" }),
          field: "wonum",
        },
        {
          label: this.$t("message.magic.startDate", { value: "default" }),
          field: "startdate",
          dataFormat: this.formatedDate
        },
        {
          label: this.$t("message.magic.endDate", { value: "default" }),
          field: "enddate",
          dataFormat: this.formatedDate
        },
        {
          label: this.$t("message.magic.desc", { value: "default" }),
          field: "description",
        },
        {
          label: "Worklog",
          field: "ldescription",
          dataFormat: this.filterHtml
        },
        {
          label: this.$t("message.magic.location", { value: "default" }),
          field: "locationdesc",
        },
        {
          label: this.$t("message.magic.jobplan", { value: "default" }),
          field: "wonum",
          dataFormat: this.getJobPlanTypeForExport
        },
      ];
    },

    headersPMTable() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "topLevel",
          sortable: true,
        },

        {
          text: this.$t("message.magic.workorder", { value: "default" }),
          value: "wonum",
          sortable: true,
        },
        {
          text: this.$t("message.magic.startDate", { value: "default" }),
          value: "startdate",
          sortable: true,
        },
        {
          text: this.$t("message.magic.endDate", { value: "default" }),
          value: "enddate",
          sortable: true,
        },
        {
          text: this.$t("message.magic.desc", { value: "default" }),
          value: "description",
          sortable: false,
        },
        {
          text: "Worklog",
          value: "ldescription",
          sortable: false,
        },
        {
          text: this.$t("message.magic.location", { value: "default" }),
          value: "locationdesc",
          sortable: false,
        },
        {
          text: this.$t("message.magic.details", { value: "default" }),
          value: "action",
          sortable: false,
        },
      ];
    },

    headerSrTable() {
      return [
        {
          text: this.$t("message.magic.id", { value: "default" }),
          value: "ticketid",
          sortable: true,
        },
        {
          text: this.$t("message.magic.description", { value: "default" }),
          value: "description",
          sortable: false,
        },
        {
          text: this.$t("message.magic.status", { value: "default" }),
          value: "status",
          sortable: true,
        },
        {
          text: this.$t("message.magic.date", { value: "default" }),
          value: "reportdate",
          sortable: true,
        },
      ];
    },

    headersProtocol() {
      return [
        {
          text: this.$t("message.magic.date", { value: "default" }),
          value: "createdate",
        },
        {
          text: this.$t("message.magic.details", { value: "default" }),
          value: "document",
        },
      ];
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  color: #fff;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
}

.value {
  font-size: 16px;
}
</style>
